import { AppRoot, ConfigProvider } from '@vkontakte/vkui';
import './coffeeTheme.css';

const coffeeTokensClassNames = {
  light: 'coffee-theme',
  dark: 'coffee-theme',
};

export function CoffeeTheme({ children }) {
  return (
    <ConfigProvider colorScheme="light" tokensClassNames={coffeeTokensClassNames}>
      <AppRoot mode="full">
        <div className="coffee-theme payment-result-shell">{children}</div>
      </AppRoot>
    </ConfigProvider>
  );
}
